<template lang="pug">
EditableControl(v-if="value_ !== undefined && value_ !== null" :id="id" :displayValue="displayValue" :bus="bus" :editing="editing" :editByDefault="editByDefault" :errors="errors" :navigationRoute="navigationRoute" :isDisabled="isDisabled")
  toggle-button.toggle(:id='id + "_toggle"' :css-colors="true" v-model="value_" :labels="labels" :width="width" @change="onToggleChange" :disabled="isDisabled")
</template>

<script>
import { Events } from "../Block/index";
import { mixins } from "../EditableControl/mixins";
import "./scss";

export default {
  name: "Toggle",
  mixins: [mixins("value")],
  props: {
    width: {
      type: Number,
      default: () => 50,
    },
    value: {
      type: Boolean,
      required: false,
    },
    labels: {
      type: Object,
      default: undefined,
    },
  },
  created() {
    this.bus.$on(Events.Cancel, this.onCancelled);
  },
  destroyed() {
    this.bus.$off(Events.Cancel, this.onCancelled);
  },
  watch: {
    isDisabled() {
      this.displayValue = this.getDisplayValue("value_", this.value_);
    },
  },
  methods: {
    onToggleChange(event) {
      this.$emit(Events.Change, { id: this.id, value: event.value });
      this.bus.$emit(Events.Change, { id: this.id, value: event.value });
    },
    onCancelled() {
      this.$emit(Events.Cancel, { id: this.id, value: this.value });
    },
  },
};
</script>
